// src/pages/About/About.jsx
import React from 'react';
import AboutUs from './Components/AboutUs';

function About() {
  return <AboutUs />;
}

export default About;